









































































import Vue from 'vue'
import { mainSiteLink } from '@/utils/plugins/links'

export default Vue.extend({
  name: 'SiteResponsiveMenu',
  methods: {
    getFullLink (route: string) {
      return mainSiteLink + route
    }
  }
})
